"use client";
import { PatientDetailsDrawer } from "./patient-details-drawer";
import { usePatientStore } from "../store/usePatientStore";

export function GlobalPatientDetailsDrawer() {
  const selectedPatientId = usePatientStore((s) => s.selectedPatientId);
  const setSelectedPatientId = usePatientStore((s) => s.setSelectedPatientId);

  return (
    <PatientDetailsDrawer
      patientId={selectedPatientId}
      onClose={() => setSelectedPatientId(null)}
    />
  );
}
